import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { KompaktGrundstueckComponent } from '../../../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import { HistoryDirective } from '../../../../shared/directives/history.directive';
import { KompaktTimepointComponent } from '../../../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { LinkComponent, NavTarget } from '../../../../shared/components/link/link.component';
import { DokulinkComponent } from '../../../../shared/components/dokulink/dokulink.component';
import { MapsComponent } from '../../../../shared/widgets/maps/maps.component';
import { AuszugComponent } from '../../../../shared/components/auszug/auszug.component';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { DecimalHochkommaPipe } from '../../../../shared/pipes/simple/decimalHochkomma.pipe';
import { GrundstuecknummerPipe } from '../../../../shared/pipes/simple/grundstuecknummer.pipe';
import { DokulinkItemBuilderFactory } from '../../../../shared/components/dokulink/dokulinkItemBuilderFactory';
import { keysToTranslate } from '../../../../../i18n/keys-to-translate';
import { GebaeudeAufGrundstueckDetailEntryMeta } from '../../../../core/av-api';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { CmisComponent } from '../../../../shared/components/cmis/cmis.component';

@Component({
  selector: 'cap-gebaeude-auf-grundstueck',
  templateUrl: './gebaeude-auf-grundstueck.component.html',
  styleUrls: ['./gebaeude-auf-grundstueck.component.scss'],
  imports: [
    TranslatePipe,
    KompaktGrundstueckComponent,
    HistoryDirective,
    KompaktTimepointComponent,
    LinkComponent,
    DokulinkComponent,
    CmisComponent,
    MapsComponent,
    AuszugComponent,
    NgTemplateOutlet,
    DecimalHochkommaPipe,
    GrundstuecknummerPipe,
    AsyncPipe
  ]
})
export class GebaeudeAufGrundstueckComponent {
  navTargets = NavTarget;

  gebAufGrundstueckVM: Array<GebaeudeAufGrundstueckVM>;

  constructor(
    protected dokuLinkBuilderFactory: DokulinkItemBuilderFactory,
    public appformatConfigService: FormatConfigService
  ) {
    keysToTranslate<string>(['StehtAufFolgendenGrundstuecken']);
  }

  @Input()
  set gebAufGrundstueck(value: Array<GebaeudeAufGrundstueckDetailEntryMeta>) {
    if (!value) {
      return;
    }
    this.update(value);
  }

  update(value: Array<GebaeudeAufGrundstueckDetailEntryMeta>) {
    this.gebAufGrundstueckVM = new Array<GebaeudeAufGrundstueckVM>();
    value.forEach((element) => {
      this.gebAufGrundstueckVM.push(new GebaeudeAufGrundstueckVM(element));
    });
  }
}

class GebaeudeAufGrundstueckVM {
  model: GebaeudeAufGrundstueckDetailEntryMeta;

  constructor(gebaeudeMasterDetailEntry: GebaeudeAufGrundstueckDetailEntryMeta) {
    this.model = gebaeudeMasterDetailEntry;
  }
}
